import React, { createContext, useMemo } from 'react'
import useModal from './../hooks/useModal'
import useBee from './../hooks/useBee'
import useEvent from './../hooks/useEvent'
import theme from './../config/theme'

const selectStyle = (currentTheme) => {
  switch(currentTheme) {
    case 'dark':
      return theme.dark
    case 'eightbit':
      return theme.eightbit
    default:
      return theme.coral
  }
}

export const AppContext = createContext()

export const AppProvider = (props) => {
  const { children } = props

  const modalAPI = useModal()
  const beeAPI = useBee()
  const eventAPI = useEvent()

  const { store } = beeAPI

  
  const value = useMemo(() => {
    const style = selectStyle(store.theme)
    return { beeAPI, eventAPI, modalAPI, theme: style }
  },
  [beeAPI, eventAPI, modalAPI, store.theme])

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  )
}
